export const OnAirSign = ({ on, size = "md", testId = "on-air-sign" }) => {
  const pad = size === "sm" ? "px-2 py-0.5 text-[10px]" : "px-4 py-1.5 text-sm";
  return (
    <span
      data-testid={testId}
      data-on-air={on ? "true" : "false"}
      className={`mono inline-flex items-center gap-2 rounded-[3px] border font-bold tracking-[0.25em] ${pad} ${
        on
          ? "border-pink-400 bg-pink-500/15 text-pink-300 glow-pink onair-pulse"
          : "border-zinc-700 bg-black/40 text-zinc-500"
      }`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${on ? "bg-pink-400" : "bg-zinc-600"}`} />
      {on ? "ON AIR" : "OFF AIR"}
    </span>
  );
};
